import { computed, ref } from 'vue'
import { breakpointsTailwind, useBreakpoints, useMediaQuery } from '@vueuse/core'

const isBeforePrint = ref(false)
let isPrintListenersBound = false

const bindPrintListeners = () => {
  if (typeof window === 'undefined' || isPrintListenersBound) return

  window.addEventListener('beforeprint', () => {
    isBeforePrint.value = true
  })

  window.addEventListener('afterprint', () => {
    isBeforePrint.value = false
  })

  isPrintListenersBound = true
}

export const useResponsive = () => {
  bindPrintListeners()

  const breakpoints = useBreakpoints(breakpointsTailwind)
  const isPrintMedia = useMediaQuery('print')
  const isPrint = computed(() => isBeforePrint.value || isPrintMedia.value)

  const smallerSm = breakpoints.smaller('sm')
  const greaterSm = breakpoints.greater('sm')
  const smallerMd = breakpoints.smaller('md')
  const greaterMd = breakpoints.greater('md')
  const smallerLg = breakpoints.smaller('lg')

  const isMobile = computed(() => !isPrint.value && smallerSm.value)
  const isTablet = computed(() => !isPrint.value && greaterSm.value && smallerMd.value)
  const toTablet = computed(() => !isPrint.value && smallerMd.value)
  const isDesktop = computed(() => !isPrint.value && greaterMd.value && smallerLg.value)

  return {
    isMobile,
    isTablet,
    toTablet,
    isDesktop,
  }
}
